import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Section, ColorBlock, P, PD, A } from './BlogShared.jsx';
import closingBg from '../../assets/blog/closing-bg.png';

export const ClosingSection = ({ onCTA }) => (
  <Section
    sx={{
      position: 'relative',
      overflow: 'hidden',
      '& > div': { position: 'relative', zIndex: 2 },
    }}
  >
    {/* Background — full-bleed edge to edge */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '50%',
        width: '100vw',
        marginLeft: '-50vw',
        zIndex: 0,
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(135deg, ${PD}F0, ${P}E8 40%, ${A}D0 100%)`,
        },
      }}
    >
      <Box
        component="img"
        src={closingBg}
        alt=""
        sx={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }}
      />
    </Box>

    {/* Content */}
    <Box sx={{ position: 'relative', zIndex: 2, textAlign: 'center', py: { xs: 4, md: 6 } }}>
      <Typography
        sx={{
          fontSize: { xs: '1.5rem', sm: '2rem', md: '2.6rem' },
          fontWeight: 300,
          fontFamily: "'Inter', sans-serif",
          color: '#fff',
          lineHeight: 1.2,
          letterSpacing: '-0.02em',
          mb: 2,
        }}
      >
        The best restaurants don't just operate well.
        <br />
        <span style={{ opacity: 0.7 }}>They make </span>
        <span
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontWeight: 700,
            fontStyle: 'italic',
            background: 'linear-gradient(90deg, #FFD54F, #FF8A80)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          better decisions, faster.
        </span>
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: '1rem', md: '1.15rem' },
          fontWeight: 400,
          color: 'rgba(255,255,255,0.7)',
          mb: 5,
        }}
      >
        Karobar gives you that edge.
      </Typography>

      <Box
        onClick={onCTA}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.2,
          px: 4,
          py: 2,
          borderRadius: '14px',
          background: 'rgba(255,255,255,0.95)',
          color: PD,
          fontWeight: 700,
          fontSize: '0.95rem',
          cursor: 'pointer',
          boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
          transition: 'all 0.3s cubic-bezier(.16,1,.3,1)',
          '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
          },
        }}
      >
        Create Your Free Account <ArrowForward sx={{ fontSize: 18, color: A }} />
      </Box>

      <Typography
        sx={{
          mt: 3,
          fontSize: '0.8rem',
          fontWeight: 400,
          color: 'rgba(255,255,255,0.5)',
        }}
      >
        Start simple. Scale smart. No commitment needed.
      </Typography>
    </Box>
  </Section>
);
